// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.job_name {
  font-size: 11px !important;
  box-sizing: border-box !important;
  border: none !important;
  box-shadow: 1px 1px 2px 2px lightgrey !important;
  outline: 0 !important;
  background-color: #fff !important;
  color: rgba(0, 0, 0, 0.87) !important;
  width: 100% !important;
  padding: 0 15px !important;
  line-height: 30px !important;
  height: 30px !important;
  border-radius: 5px !important;
  padding-left: 5px !important;
  padding-right: 9% !important;
}

.modified_by {
  font-size: 11px !important;
  box-sizing: border-box !important;
  border: none !important;
  box-shadow: 1px 1px 2px 2px lightgrey !important;
  outline: 0 !important;
  background-color: #eceeef !important;
  opacity: 1;
  color: rgba(0, 0, 0, 0.87) !important;
  width: 100% !important;
  padding: 0 15px !important;
  line-height: 30px !important;
  height: 30px !important;
  border-radius: 5px !important;
  padding-left: 5px !important;
  padding-right: 9% !important;
}

.active_card {
  border-left: 4px solid #07a36e;
}

.failed_card {
  border-left: 4px solid #da606c;
}

::ng-deep.jobmodal .modal-dialog {
  max-width: 97% !important;
  max-height: 40% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.jobmodal {
  top: 4% !important;
}

.job_text_field {
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
}

.job_text {
  color: black;
  top: 7px;
}

.mat-mdc-icon-button.mat-mdc-button-base {
  display: none !important;
}

::ng-deep.jobpaginator .mat-mdc-tooltip-trigger.mat-mdc-icon-button .mat-mdc-button-persistent-ripple {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/job/job.component.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,iCAAA;EACA,uBAAA;EACA,gDAAA;EACA,qBAAA;EACA,iCAAA;EACA,qCAAA;EACA,sBAAA;EACA,0BAAA;EACA,4BAAA;EACA,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;AACF;;AAEA;EACA,0BAAA;EACA,iCAAA;EACA,uBAAA;EACA,gDAAA;EACA,qBAAA;EACA,oCAAA;EACA,UAAA;EACA,qCAAA;EACA,sBAAA;EACA,0BAAA;EACA,4BAAA;EACA,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;AACA;;AAEA;EACE,8BAAA;AACF;;AACA;EACE,8BAAA;AAEF;;AAAA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAGF;;AADA;EACE,kBAAA;AAIF;;AAFA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;AAKF;;AAFA;EACE,YAAA;EACE,QAAA;AAKJ;;AAFA;EACE,wBAAA;AAKF;;AAAG;EACC,wBAAA;AAGJ","sourcesContent":[".job_name{\r\n  font-size: 11px !important;\r\n  box-sizing: border-box !important;\r\n  border: none !important;\r\n  box-shadow: 1px 1px 2px 2px lightgrey!important;\r\n  outline: 0 !important;\r\n  background-color: #fff !important;\r\n  color: rgba(0, 0, 0, 0.87) !important;\r\n  width: 100% !important;\r\n  padding: 0 15px !important;\r\n  line-height: 30px !important;\r\n  height: 30px !important;\r\n  border-radius: 5px !important;\r\n  padding-left: 5px !important;\r\n  padding-right: 9% !important;\r\n}\r\n\r\n.modified_by{\r\nfont-size: 11px !important;\r\nbox-sizing: border-box !important;\r\nborder: none !important;\r\nbox-shadow: 1px 1px 2px 2px lightgrey!important;\r\noutline: 0 !important;\r\nbackground-color: #eceeef!important;\r\nopacity: 1;\r\ncolor: rgba(0, 0, 0, 0.87) !important;\r\nwidth: 100% !important;\r\npadding: 0 15px !important;\r\nline-height: 30px !important;\r\nheight: 30px !important;\r\nborder-radius: 5px !important;\r\npadding-left: 5px !important;\r\npadding-right: 9% !important;\r\n}\r\n\r\n.active_card {\r\n  border-left: 4px solid #07a36e;\r\n}\r\n.failed_card {\r\n  border-left: 4px solid #da606c;\r\n}\r\n::ng-deep.jobmodal .modal-dialog {\r\n  max-width: 97%!important;\r\n  max-height:40%!important;\r\n  height: 60%!important;\r\n  margin: auto!important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.jobmodal{\r\n  top: 4%!important;\r\n}\r\n.job_text_field{\r\n  font-size: 12px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 90% !important;\r\n  display: inline-block;\r\n}\r\n\r\n.job_text{\r\n  color: black;\r\n    top: 7px;\r\n}\r\n\r\n.mat-mdc-icon-button.mat-mdc-button-base  {\r\n  display: none !important;\r\n}\r\n\r\n::ng-deep.jobpaginator{\r\n  .mat-mdc-tooltip-trigger.mat-mdc-icon-button{\r\n   .mat-mdc-button-persistent-ripple {\r\n    display: none !important;\r\n  }\r\n}\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
